import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Question' })({
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        padding: 40,
        borderRadius: 24,
        background: 'rgba(255, 255, 255, 0.03)',
        '& a': {
            color: '#FF7A38',
            textDecoration: 'none',
            transition: 'opacity 0.2s',
            '&:hover': {
                opacity: 0.8
            }
        }
    },
    title: {
        margin: 0,
        padding: 0,
        color: '#fff',
        fontSize: 20,
        fontWeight: 700,
        lineHeight: '30px',
        letterSpacing: '-0.2px'
    },
    content: {
        margin: 0,
        padding: 0,
        color: '#8E8E8E',
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '24px',
        whiteSpace: 'pre-wrap'
    }
});
